;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.teamFilter = (function () {
    const initialize = function () {
      $('.team-filter .js-controlLink').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const desiredLook = $(this).attr('data-filter-button')
        // console.log($this, desiredLook)

        if (desiredLook === 'all') {
          $('.filterable .team-group').removeClass('hidden')
        } else {
          $('.filterable .team-group').addClass('hidden')
          $('.filterable .team-group.team-' + desiredLook).removeClass('hidden')
        }
        $this.parent().addClass('is-selected').siblings().removeClass('is-selected')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.teamFilter.initialize()
  })
}(jQuery, window))
